import { render, staticRenderFns } from "./DatosOrganos.vue?vue&type=template&id=2e0e85bd&scoped=true"
import script from "./DatosOrganos.vue?vue&type=script&lang=js"
export * from "./DatosOrganos.vue?vue&type=script&lang=js"
import style0 from "./DatosOrganos.vue?vue&type=style&index=0&id=2e0e85bd&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0e85bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e0e85bd')) {
      api.createRecord('2e0e85bd', component.options)
    } else {
      api.reload('2e0e85bd', component.options)
    }
    module.hot.accept("./DatosOrganos.vue?vue&type=template&id=2e0e85bd&scoped=true", function () {
      api.rerender('2e0e85bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/constitucion/infoBase/DatosOrganos.vue"
export default component.exports